module.exports = __webpack_public_path__ + "assets/img/d-card.91bbad6b.png";